import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, Form } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import UserData from "../config/config";
import "./table.css";

const Table = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [records, setRecords] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [messageType, setMessageType] = useState();
  // const [newMessage, setNewMessage] = useState("");

  console.log("historyData", historyData);

  const handleCreateModalShow = () => setShowCreateModal(true);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const handleViewModalClose = () => {
    setShowViewModal(false);
    setSelectedRecord(null);
    setHistoryData(null);
  };

  const handleRowClick = async (record) => {
    setSelectedRecord(record);
    setShowViewModal(true);
    setLoadingHistory(true);
    setHistoryData(null);

    try {
      const res = await axios.post(UserData.USER_POST_HISTORY, {
        req_id: record.id,
      });
      if (res.data?.status === "success" && res.data?.data?.length > 0) {
        setHistoryData(res.data.data);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching history data:", error);
      setHistoryData([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  const getRecords = async () => {
    try {
      const res = await axios.get(UserData.USER_GET_RECORD);
      setRecords(res.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch records:", error);
    }
  };

  useEffect(() => {
    getRecords();
  }, []);

  const handleCreate = async () => {
    if (!newMessage || !messageType) {
      alert("Please select a category and enter a message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(UserData.USER_POST_REQUEST, {
        req_msg: newMessage,
        req_cat: messageType,
      });
      const res = await axios.get(UserData.USER_GET_RECORD);
      setRecords(res.data?.data || []);
      console.log("creter mesage====", res);
      handleCreateModalClose();
    } catch (error) {
      console.error("Failed to create record:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showCreateModal) {
      setMessageType("");
    }
  }, [showCreateModal]);

  const handleCreateModalClose = () => {
    setShowCreateModal(false);
    setNewMessage("");
    setMessageType(""); // <-- reset radio selection
  };

  return (
    <>
      {/* Create Message Button */}
      <div className="d-flex justify-content-end px-3 pt-5">
        <button
          type="button"
          className="mb-1 btn btn-primary d-flex align-items-center"
          onClick={handleCreateModalShow}
        >
          <FaPlus className="me-2" />
          Create Message
        </button>
      </div>
      {/* Create Message Modal */}
      <Modal show={showCreateModal} onHide={handleCreateModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Radio Buttons */}
            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="GR"
                  name="messageType"
                  id="messageTypeGR"
                  value="GR"
                  checked={messageType === "GR"}
                  onChange={(e) => setMessageType(e.target.value)}
                />
                <Form.Check
                  type="radio"
                  label="PVC"
                  name="messageType"
                  id="messageTypePVC"
                  value="PVC"
                  checked={messageType === "PVC"}
                  onChange={(e) => setMessageType(e.target.value)}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter message"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCreateModalClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleCreate} disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Creating...
              </>
            ) : (
              "Create"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* View Record Modal */}
      <Modal show={showViewModal} onHide={handleViewModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Message Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-scroll">
          {selectedRecord ? (
            loadingHistory ? (
              <div className="d-flex justify-content-center align-items-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : historyData?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr className="text-center">
                    <th>User Number</th>
                    <th>Status</th>
                    <th>Date and Time</th>
                  </tr>
                </thead>
                <tbody>
                  {historyData.map((entry, idx) => (
                    <tr key={idx} className="text-center">
                      <td>{entry.user_number}</td>
                      <td
                        className={
                          entry.is_sent == 0 ? "text-danger" : "text-success"
                        }
                      >
                        {entry.is_sent == 0 ? "Pending" : "Completed"}
                      </td>
                      <td>{entry.sent_date_time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-center text-muted">Message not sent yet.</p>
            )
          ) : (
            <p>No data found</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleViewModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Records Table */}
      <div className="table-responsive px-3">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Date & Time</th>
              <th>Message</th>
              <th>Category</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {records.length > 0 ? (
              records.map((record, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(record)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{record.req_date_time}</td>
                  {/* <td
                    dangerouslySetInnerHTML={{
                      __html: record.req_msg
                        .replace(/[\\*]/g, "") // removes \ and *
                        .replace(/\\n/g, "<br />"), // replaces literal \n with <br>
                    }}
                  ></td> */}
                  <td>
                    {record.req_msg
                      .replace(/\\n/g, " ")
                      .replace(/\\/g, "")
                      .replace(/\*/g, "")}{" "}
                  </td>
                  <td>{record.req_cat}</td>
                  <td
                    className={
                      record.req_status == 0 ? "text-danger" : "text-success"
                    }
                  >
                    {record.req_status == 0
                      ? "Pending"
                      : record.req_status == 1
                      ? "Completed"
                      : ""}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                Completed
                <td colSpan="3" className="text-center">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
